// removed by extract-text-webpack-plugin
module.exports = {"collection":"_2fbzv","title":"_32dbB","description":"_27PGV","photo":"_3PxOA","content":"_1StWV"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/CollectionTile/index.sass
// module id = 1472
// module chunks = 1